// Centralized resolver for where to send a user after login, based on their data
// Inputs:
// - user: object returned from user/detail/
// - opts: { lng: string, appContentType: string, notFoundCookie?: any }
// Returns a pathname string or null
export const resolvePostLoginPath = (user, opts) => {
  const { lng, appContentType, notFoundCookie } = opts || {};

  const shopsRaw = user?.shops ?? [];
  const shops = Array.isArray(shopsRaw)
    ? shopsRaw
    : // Fallback if shops is an object with numeric keys
      Object.keys(shopsRaw || {})
        .map((k) => shopsRaw[k])
        .filter(Boolean);

  const shopsCount = shops.length;
  const firstShop = shops[0];
  const isAdmin = user?.email === "info@permoniq.com";

  if (shopsCount === 0) {
    return `/${lng}/app/register-shop/`;
  }

  if (!isAdmin && shopsCount === 1 && firstShop?.status_create !== "end") {
    return `/${lng}/app/register-shop/`;
  }

  if (!isAdmin && shopsCount === 1 && firstShop?.status_create === "end") {
    return `/${lng}/app/${appContentType}/`;
  }

  if (shopsCount > 1 && !notFoundCookie) {
    return `/${lng}/app/shop-option/`;
  }

  return null; // no redirect (e.g., stay where you are or show 404)
};

export default resolvePostLoginPath;
